import Vue from 'vue';

// Domain
import { LinkedGoalStateManager } from '../../domain/state/linked-goal-state-manager';
import LinkedGoalState from '../../domain/state/linked-goal-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class LinkedGoalVueStateManager implements LinkedGoalStateManager {
  private _state: LinkedGoalState = Vue.observable<LinkedGoalState>(
    new LinkedGoalState(),
  );

  private readonly observers: Observer[] = [];

  get state(): LinkedGoalState {
    return this._state;
  }

  set state(value: LinkedGoalState) {
    this._state = value;
  }

  patch(state: Partial<LinkedGoalState>) {
    type Keys = keyof LinkedGoalState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll(): void {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer): void {
    this.observers.push(observer);
  }
}
